import { API } from "@/lib/api";
import { getToken } from "@/lib/auth";

export const CITATION = /(\[[^\]]+?,\s*(?:Pages?|Sections?)\s+\d+(?:\s*[-–,]\s*(?:(?:Pages?|Sections?)\s+)?\d+)*\])/g;
export const IS_CITATION = /^\[[^\]]+?,\s*(?:Pages?|Sections?)\s+\d+(?:\s*[-–,]\s*(?:(?:Pages?|Sections?)\s+)?\d+)*\]$/;

export async function streamChat(path, body, onEvent) {
  const resp = await fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify(body),
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(typeof err.detail === "string" ? err.detail : "Chat failed");
  }
  const reader = resp.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop() || "";
    for (const p of parts) {
      if (!p.startsWith("data:")) continue;
      try { onEvent(JSON.parse(p.slice(5).trim())); } catch (err) { console.warn("Skipped malformed stream event", err); }
    }
  }
}
